import { addBreadcrumb } from '@sentry/react';
import { redact } from '@x1/util-logging';
import { IEnvironment } from 'relay-runtime';
import { Environment, Network, Observable, RecordSource, RequestParameters, Store, Variables } from 'relay-runtime';

import { Domain, fetch } from 'src/clients/Network/http/fetch';

const mkFetchFn = (domain: Domain) => (params: RequestParameters, variables: Variables) => {
  const body = {
    query: params.text,
    operationName: params.name,
    variables,
  };
  addBreadcrumb({
    message: 'GraphQL Fetch',
    level: 'debug',
    data: {
      ...body,
      variables: redact(JSON.stringify(body.variables)),
    },
  });
  const response = fetch(domain, '/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  return Observable.from(response.then((data) => data.json()));
};

export function createEnvironment(domain: Domain): IEnvironment {
  return new Environment({
    network: Network.create(mkFetchFn(domain)),
    store: new Store(new RecordSource()),
    treatMissingFieldsAsNull: true,
  });
}
